import { useState } from "react";

export function VarsField({
  value,
  onChange,
}: {
  value: Record<string, string>;
  onChange: (v: Record<string, string>) => void;
}) {
  const [newKey, setNewKey] = useState("");
  const entries = Object.entries(value);

  function updateKey(oldKey: string, nextKey: string) {
    if (nextKey === oldKey) return;
    if (!nextKey.trim()) return;
    const next: Record<string, string> = {};
    for (const [k, v] of entries) {
      next[k === oldKey ? nextKey.trim() : k] = v;
    }
    onChange(next);
  }
  function updateValue(key: string, val: string) {
    onChange({ ...value, [key]: val });
  }
  function remove(key: string) {
    const next = { ...value };
    delete next[key];
    onChange(next);
  }
  function add() {
    const key = newKey.trim();
    if (!key) return;
    if (Object.prototype.hasOwnProperty.call(value, key)) return;
    onChange({ ...value, [key]: "" });
    setNewKey("");
  }

  return (
    <div className="space-y-1.5">
      {entries.length === 0 ? (
        <div className="text-xs text-neutral-400 italic">No variables yet.</div>
      ) : (
        entries.map(([k, v]) => (
          <div key={k} className="grid grid-cols-[10rem_1fr_auto] gap-2 items-center">
            <input
              defaultValue={k}
              onBlur={(e) => updateKey(k, e.target.value)}
              className="rounded border px-2 py-1.5 text-sm font-mono"
              placeholder="key"
              title="Variable name (referenced as {key} in text)"
            />
            <input
              value={v}
              onChange={(e) => updateValue(k, e.target.value)}
              className="rounded border px-2 py-1.5 text-sm"
              placeholder="value"
            />
            <button
              type="button"
              onClick={() => remove(k)}
              className="text-xs text-neutral-500 hover:text-red-600 px-2"
              title="Remove variable"
            >
              ✕
            </button>
          </div>
        ))
      )}
      <div className="grid grid-cols-[10rem_1fr_auto] gap-2 items-center pt-1">
        <input
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          className="rounded border px-2 py-1.5 text-sm font-mono"
          placeholder="newKey"
        />
        <button
          type="button"
          onClick={add}
          disabled={!newKey.trim()}
          className="text-sm text-neutral-700 hover:text-neutral-900 underline justify-self-start disabled:opacity-30 disabled:no-underline"
        >
          + Add variable
        </button>
      </div>
    </div>
  );
}
